import * as React from "react";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
import { Colors } from "../constants/styles";
import { formatDate } from "../constants/helper";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
  tableBottomRightBorder: {
    borderWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const useStylesNoColor = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.grey800,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

export function ShowTableUser({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Username
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tipe User
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Periode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kwitansi
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No Terakhir
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Cabang</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarUser/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.username}
              </TableCell>
              <TableCell>{user.tipeUser}</TableCell>
              <TableCell>{user.tutupperiode.namaPeriode}</TableCell>
              <TableCell>{user.kodeKwitansi}</TableCell>
              <TableCell>{user.noTerakhir}</TableCell>
              <TableCell>
                {user.cabang.id} - {user.cabang.namaCabang}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableKategoriJaminan({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Bunga/Bulan</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/kategoriJaminan/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.namaKategori}
              </TableCell>
              <TableCell>{user.bungaPerBulanKategori}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableJenisJaminan({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Bunga/Bulan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Lama Jatuh Tempo
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pengali
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Kategori</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/jenisJaminan/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.namaJenis}
              </TableCell>
              <TableCell>{user.bungaPerBulanJenis}</TableCell>
              <TableCell>{user.lamaJatuhTempo}</TableCell>
              <TableCell>{user.pengali}</TableCell>
              <TableCell>{user.kategorijaminan.namaKategori}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTablePlafonJaminan({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Merk
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tipe
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Max. Plafon
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Jenis
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/plafonJaminan/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.merkPlafon}
              </TableCell>
              <TableCell>{user.tipePlafon}</TableCell>
              <TableCell>{user.maxPlafon.toLocaleString("de-DE")}</TableCell>
              <TableCell>{user.jenisjaminan.namaJenis}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableMarketing({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Telepon</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/marketing/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.kodeMarketing}
              </TableCell>
              <TableCell>{user.namaMarketing}</TableCell>
              <TableCell>{user.teleponMarketing}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableTingkatRisiko({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              TPPU
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              TPPT
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              PPSPM
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/tingkatRisiko/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.kodeTingkatRisiko}
              </TableCell>
              <TableCell>{user.namaTingkatRisiko}</TableCell>
              <TableCell>{user.tppuTingkatRisiko}</TableCell>
              <TableCell>{user.tpptTingkatRisiko}</TableCell>
              <TableCell>{user.ppspmTingkatRisiko}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableKualitasPiutang({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Dari Hari
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Sampai Hari
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/kualitasPiutang/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.kodeKualitasPiutang}
              </TableCell>
              <TableCell>{user.namaKualitasPiutang}</TableCell>
              <TableCell style={{ textAlign: "right" }}>
                {user.dariHari}
              </TableCell>
              <TableCell style={{ textAlign: "right" }}>
                {user.sampaiHari}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableSurveyor({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Jenis
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Telepon</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/surveyor/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.kodeSurveyor}
              </TableCell>
              <TableCell>{user.namaSurveyor}</TableCell>
              <TableCell>{user.jenisSurveyor}</TableCell>
              <TableCell>{user.teleponSurveyor}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableEksekutor({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Telepon</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/eksekutor/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.kodeEksekutor}
              </TableCell>
              <TableCell>{user.namaEksekutor}</TableCell>
              <TableCell>{user.teleponEksekutor}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableTipe({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Tipe
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Rangka
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Mesin
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Isi
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Merk</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/tipe/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.kodeTipe}
              </TableCell>
              <TableCell>{user.namaTipe}</TableCell>
              <TableCell>{user.noRangka}</TableCell>
              <TableCell>{user.noMesin}</TableCell>
              <TableCell>{user.isi}</TableCell>
              <TableCell>{user.merk}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableWarna({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>Nama Warna</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/warna/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.namaWarna}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableJenisCOA({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Nama</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/jenisCoa/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.kodeJenisCOA}
              </TableCell>
              <TableCell>{user.namaJenisCOA}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableGroupCOA({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Jenis COA</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/groupCoa/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.kodeGroupCOA}
              </TableCell>
              <TableCell>{user.namaGroupCOA}</TableCell>
              <TableCell>
                {user.jeniscoa.kodeJenisCOA} - {user.jeniscoa.namaJenisCOA}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableSubGroupCOA({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Jenis COA
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Group COA</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/subGroupCoa/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.kodeSubGroupCOA}
              </TableCell>
              <TableCell>{user.namaSubGroupCOA}</TableCell>
              <TableCell>
                {user.jeniscoa.kodeJenisCOA} - {user.jeniscoa.namaJenisCOA}
              </TableCell>
              <TableCell>
                {user.groupcoa.kodeGroupCOA} - {user.groupcoa.namaGroupCOA}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableCOA({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Jenis Saldo
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kas Bank
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kelompok COA
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Group COA
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Sub Group COA
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              OJK Laba Rugi
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              OJK Neraca
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              OJK Arus Kas Debet
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              OJK Arus Kas Kredit
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/coa/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.kodeCOA}
              </TableCell>
              <TableCell>{user.namaCOA}</TableCell>
              <TableCell>{user.jenisSaldo}</TableCell>
              <TableCell>{user.kasBank}</TableCell>
              <TableCell>
                {user.jeniscoa.kodeJenisCOA} - {user.jeniscoa.namaJenisCOA}
              </TableCell>
              <TableCell>
                {user.groupcoa.kodeGroupCOA} - {user.groupcoa.namaGroupCOA}
              </TableCell>
              <TableCell>
                {user.subgroupcoa.kodeSubGroupCOA} -{" "}
                {user.subgroupcoa.namaSubGroupCOA}
              </TableCell>
              <TableCell>{user.kodeCOAOJKLabaRugi}</TableCell>
              <TableCell>{user.kodeCOAOJKNeraca}</TableCell>
              <TableCell>{user.kodeCOAOJKArusKasDebet}</TableCell>
              <TableCell>{user.kodeCOAOJKArusKasKredit}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableFormLabaRugiOJK({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Column 1
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Column 2
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Column 3
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode COA OJK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Urutan COA OJK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Dari
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Sampai
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Menu
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/formLabaRugiOJK/${user.id}`);
              }}
            >
              <TableCell
                component="th"
                scope="row"
                sx={{ fontWeight: user.isMenu === true && "800" }}
              >
                {user.column1}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.column2}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.column3}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.kodeCOAOJK}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.urutanCOAOJK}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.dariKodeCOAOJK}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.sampaiKodeCOAOJK}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.isMenu === true && "V"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableFormNeracaOJK({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Column 1
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Column 2
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Column 3
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode COA OJK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Urutan COA OJK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Dari
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Sampai
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Menu
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/formNeracaOJK/${user.id}`);
              }}
            >
              <TableCell
                component="th"
                scope="row"
                sx={{ fontWeight: user.isMenu === true && "800" }}
              >
                {user.column1}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.column2}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.column3}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.kodeCOAOJK}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.urutanCOAOJK}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.dariKodeCOAOJK}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.sampaiKodeCOAOJK}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.isMenu === true && "V"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableFormArusKasOJK({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Column 1
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Column 2
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Column 3
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode COA OJK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Mutasi COA OJK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Urutan COA OJK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Dari
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Sampai
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Menu
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/formArusKasOJK/${user.id}`);
              }}
            >
              <TableCell
                component="th"
                scope="row"
                sx={{ fontWeight: user.isMenu === true && "800" }}
              >
                {user.column1}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.column2}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.column3}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.kodeCOAOJK}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.mutasiOJK}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.urutanCOAOJK}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.dariKodeCOAOJK}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.sampaiKodeCOAOJK}
              </TableCell>
              <TableCell sx={{ fontWeight: user.isMenu === true && "800" }}>
                {user.isMenu === true && "V"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableCabang({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Telepon
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>PIC</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/cabang/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.id}
              </TableCell>
              <TableCell>{user.namaCabang}</TableCell>
              <TableCell>{user.alamatCabang}</TableCell>
              <TableCell>{user.teleponCabang}</TableCell>
              <TableCell>{user.picCabang}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableGantiPeriode({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Dari Tanggal
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Sampai Tanggal
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/gantiPeriode/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.namaPeriode}
              </TableCell>
              <TableCell>{user.dariTanggal}</TableCell>
              <TableCell>{user.sampaiTanggal}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableKategoriProvinsi({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Kode OJK</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/provinsi/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.id}
              </TableCell>
              <TableCell>{user.namaProvinsi}</TableCell>
              <TableCell>{user.kodeSlikOjk}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableKabupaten({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode OJK
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Provinsi</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/kabupaten/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.id}
              </TableCell>
              <TableCell>{user.namaKabupaten}</TableCell>
              <TableCell>{user.kodeSlikOjk}</TableCell>
              <TableCell>
                {user.provinsis.id} - {user.provinsis.namaProvinsi}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableKecamatan({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Provinsi
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Kabupaten</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/kecamatan/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.id}
              </TableCell>
              <TableCell>{user.namaKecamatan}</TableCell>
              <TableCell>
                {user.provinsis.id} - {user.provinsis.namaProvinsi}
              </TableCell>
              <TableCell>
                {user.kabupaten.id} - {user.kabupaten.namaKabupaten}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableKelurahan({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Pos
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Provinsi
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kabupaten
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Kecamatan</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/kelurahan/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.id}
              </TableCell>
              <TableCell>{user.namaKelurahan}</TableCell>
              <TableCell>{user.kodePos}</TableCell>
              <TableCell>
                {user.provinsis.id} - {user.provinsis.namaProvinsi}
              </TableCell>
              <TableCell>
                {user.kabupaten.id} - {user.kabupaten.namaKabupaten}
              </TableCell>
              <TableCell>
                {user.kecamatan.id} - {user.kecamatan.namaKecamatan}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableCustomer({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama/NIK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tpt/Tgl Lahir
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              JK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pkj
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Cr. By
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/customer/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                <p>{user.namaCustomer}</p>
                <p>{user.nikCustomer}</p>
              </TableCell>
              <TableCell>
                <p>{user.tempatLahirCustomer}</p>
                <p>{formatDate(user.tanggalLahirCustomer)}</p>
              </TableCell>
              <TableCell>
                {user.jenisKelaminCustomer === "LAKI-LAKI" ? "L" : "P"}
              </TableCell>
              <TableCell>{user.alamatCustomer}</TableCell>
              <TableCell>{user.pekerjaanCustomer}</TableCell>
              <TableCell>{user.user ? user.user.username : "-"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarPengajuan({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. SBG
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pinjaman
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Kasir</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarPengajuan/pengajuan/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noAju}
              </TableCell>
              <TableCell>{user.noSbg}</TableCell>
              <TableCell>{user.tanggalAju}</TableCell>
              <TableCell>{user.customer.namaCustomer}</TableCell>
              <TableCell>{user.customer.alamatCustomer}</TableCell>
              <TableCell>{user.coa.kodeCOA}</TableCell>
              <TableCell align="right">
                {(user.pinjamanAju + user.nilaiTopup).toLocaleString("de-DE")}
              </TableCell>
              <TableCell>{user.user.username}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarInfoNasabahGadai({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. SBG
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pinjaman
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Kasir</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarInfoNasabahGadai/infoNasabahGadai/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noAju}
              </TableCell>
              <TableCell>{user.noSbg}</TableCell>
              <TableCell>{user.tanggalAju}</TableCell>
              <TableCell>{user.customer.namaCustomer}</TableCell>
              <TableCell>{user.customer.alamatCustomer}</TableCell>
              <TableCell>{user.coa.kodeCOA}</TableCell>
              <TableCell align="right">
                {(user.pinjamanAju + user.nilaiTopup).toLocaleString("de-DE")}
              </TableCell>
              <TableCell>{user.user.username}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableJaminan({ currentPosts, pengajuanId }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama Jaminan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Keterangan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Harga Pasar
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Harga Tafsiran
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Maksimal Pemberian Pinjaman
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(
                  `/daftarPengajuan/pengajuan/${pengajuanId}/${user.id}`
                );
              }}
            >
              <TableCell component="th" scope="row">
                {user.namaJam}
              </TableCell>
              <TableCell>{user.ketJam}</TableCell>
              <TableCell align="right">
                {user.hargaPasarSetempatOtrJam.toLocaleString("de-DE")}
              </TableCell>
              <TableCell align="right">
                {user.hargaTafsirJam.toLocaleString("de-DE")}
              </TableCell>
              <TableCell align="right">
                {user.maksimalPemberianPinjamanJam.toLocaleString("de-DE")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableJaminanInfoNasabahGadai({
  currentPosts,
  pengajuanId,
}) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama Jaminan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Ket.
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>
              Harga Tafsiran Rp.
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
              }}
            >
              <TableCell component="th" scope="row">
                {user.namaJam}
              </TableCell>
              <TableCell>{user.ketJam}</TableCell>
              <TableCell align="right">
                {user.hargaTafsirJam.toLocaleString("de-DE")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableJaminanInApproval({ currentPosts, pengajuanId }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama Jaminan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Ket.
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Harga Pasar
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Harga Tafsiran
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Maksimal Pemberian Pinjaman
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow key={user.id}>
              <TableCell component="th" scope="row">
                {user.namaJam}
              </TableCell>
              <TableCell>{user.ketJam}</TableCell>
              <TableCell align="right">
                {user.hargaPasarSetempatOtrJam.toLocaleString("de-DE")}
              </TableCell>
              <TableCell align="right">
                {user.hargaTafsirJam.toLocaleString("de-DE")}
              </TableCell>
              <TableCell align="right">
                {user.maksimalPemberianPinjamanJam.toLocaleString("de-DE")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarApproval({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Sbg
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Approval
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pinjaman
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>User Approve</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarApproval/approval/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noSbg}
              </TableCell>
              <TableCell>{user.noAju}</TableCell>
              <TableCell>{user.tanggalAju}</TableCell>
              <TableCell>{user.tglApproval}</TableCell>
              <TableCell>{user.customer.namaCustomer}</TableCell>
              <TableCell>{user.coa.kodeCOA}</TableCell>
              <TableCell align="right">
                {(user.pinjamanAju + user.nilaiTopup).toLocaleString("de-DE")}
              </TableCell>
              <TableCell>{user.user.username}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableApproval({ currentPosts }) {
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama Jaminan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Ket.
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Harga Pasar
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Harga Tafsiran
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Maksimal Pemberian Pinjaman
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
              }}
            >
              <TableCell component="th" scope="row">
                {user.namaJam}
              </TableCell>
              <TableCell>{user.ketJam}</TableCell>
              <TableCell align="right">
                {user.hargaPasarSetempatOtrJam.toLocaleString("de-DE")}
              </TableCell>
              <TableCell align="right">
                {user.hargaTafsirJam.toLocaleString("de-DE")}
              </TableCell>
              <TableCell align="right">
                {user.maksimalPemberianPinjamanJam.toLocaleString("de-DE")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarBuktiPencairan({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Sbg
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pinjaman
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Kasir</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarBuktiPencairan/buktiPencairan/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noSbg}
              </TableCell>
              <TableCell>{user.noAju}</TableCell>
              <TableCell>{user.tanggalAju}</TableCell>
              <TableCell>{user.customer.namaCustomer}</TableCell>
              <TableCell>{user.customer.alamatCustomer}</TableCell>
              <TableCell>{user.coa.kodeCOA}</TableCell>
              <TableCell align="right">
                {(user.pinjamanAju + user.nilaiTopup).toLocaleString("de-DE")}
              </TableCell>
              <TableCell>{user.user.username}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarTopUp({ currentPosts, searchTerm }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Sbg
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pinjaman
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Kasir</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts
            .filter((val) => {
              if (searchTerm === "") {
                return val;
              } else if (
                val.noSbg
                  .toString()
                  .toUpperCase()
                  .includes(searchTerm.toUpperCase()) ||
                val.noAju
                  .toString()
                  .toUpperCase()
                  .includes(searchTerm.toUpperCase()) ||
                val.tanggalAju
                  .toUpperCase()
                  .includes(searchTerm.toUpperCase()) ||
                val.customer.namaCustomer
                  .toString()
                  .toUpperCase()
                  .includes(searchTerm.toUpperCase()) ||
                val.customer.alamatCustomer
                  .toString()
                  .toUpperCase()
                  .includes(searchTerm.toUpperCase()) ||
                val.coa.kodeCOA
                  .toString()
                  .toUpperCase()
                  .includes(searchTerm.toUpperCase()) ||
                val.pinjamanAju == searchTerm ||
                val.user.username
                  .toString()
                  .toUpperCase()
                  .includes(searchTerm.toUpperCase())
              ) {
                return val;
              }
            })
            .map((user, index) => (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(`/daftarTopup/topup/${user.id}`);
                }}
              >
                <TableCell component="th" scope="row">
                  {user.noSbg}
                </TableCell>
                <TableCell>{user.noAju}</TableCell>
                <TableCell>{user.tanggalAju}</TableCell>
                <TableCell>{user.customer.namaCustomer}</TableCell>
                <TableCell>{user.customer.alamatCustomer}</TableCell>
                <TableCell>{user.coa.kodeCOA}</TableCell>
                <TableCell align="right">
                  {user.pinjamanAju.toLocaleString("de-DE")}
                </TableCell>
                <TableCell>{user.user.username}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarApprovalTopUp({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Sbg
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pinjaman
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Kasir</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarTopup/topup/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noSbg}
              </TableCell>
              <TableCell>{user.noAju}</TableCell>
              <TableCell>{user.tanggalAju}</TableCell>
              <TableCell>{user.customer.namaCustomer}</TableCell>
              <TableCell>{user.customer.alamatCustomer}</TableCell>
              <TableCell>{user.coa.kodeCOA}</TableCell>
              <TableCell align="right">
                {(user.pinjamanAju + user.nilaiTopup).toLocaleString("de-DE")}
              </TableCell>
              <TableCell>{user.user.username}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableTopup({ currentPosts, topupId }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No Kwitansi
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nilai Topup
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Tgl. Topup</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarTopup/topup/${topupId}/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noKwitansi}
              </TableCell>
              <TableCell align="right">
                {user.nilaiTopup.toLocaleString("de-DE")}
              </TableCell>
              <TableCell>{user.tglTopup}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarKasMasuk({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Bukti
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Kas Masuk
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              COA
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Keterangan
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Jumlah</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarKasMasuk/kasMasuk/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noBukti}
              </TableCell>
              <TableCell>{user.tglKasMasuk}</TableCell>
              <TableCell>{`${user.coa.kodeCOA} - ${user.coa.namaCOA}`}</TableCell>
              <TableCell>{user.keterangan}</TableCell>
              <TableCell align="right">
                {user.jumlah.toLocaleString("de-DE")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableKasMasuk({ id, currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Bukti
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Kas Masuk
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              COA
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Keterangan
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Jumlah</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            let newTglKasMasuk = new Date(user.kasmasuk.tglKasMasuk);
            let tempTglKasMasuk = `${newTglKasMasuk
              .getDate()
              .toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}/${(newTglKasMasuk.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${newTglKasMasuk.getFullYear()}`;
            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(`/daftarKasMasuk/kasMasuk/${id}/${user.id}`);
                }}
              >
                <TableCell component="th" scope="row">
                  {user.kasmasuk.noBukti}
                </TableCell>
                <TableCell>{tempTglKasMasuk}</TableCell>
                <TableCell>{`${user.coa.kodeCOA} - ${user.coa.namaCOA}`}</TableCell>
                <TableCell>{user.keterangan}</TableCell>
                <TableCell align="right">
                  {user.jumlah.toLocaleString("de-DE")}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarKasKeluar({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Bukti
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Kas Keluar
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              COA
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Keterangan
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Jumlah</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarKasKeluar/kasKeluar/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noBukti}
              </TableCell>
              <TableCell>{user.tglKasKeluar}</TableCell>
              <TableCell>{`${user.coa.kodeCOA} - ${user.coa.namaCOA}`}</TableCell>
              <TableCell>{user.keterangan}</TableCell>
              <TableCell align="right">
                {user.jumlah.toLocaleString("de-DE")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableKasKeluar({ id, currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Bukti
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Kas Keluar
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              COA
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Keterangan
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Jumlah</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            let newTglKasKeluar = new Date(user.kaskeluar.tglKasKeluar);
            let tempTglKasKeluar = `${newTglKasKeluar
              .getDate()
              .toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}/${(newTglKasKeluar.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${newTglKasKeluar.getFullYear()}`;
            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(`/daftarKasKeluar/kasKeluar/${id}/${user.id}`);
                }}
              >
                <TableCell component="th" scope="row">
                  {user.kaskeluar.noBukti}
                </TableCell>
                <TableCell>{tempTglKasKeluar}</TableCell>
                <TableCell>{`${user.coa.kodeCOA} - ${user.coa.namaCOA}`}</TableCell>
                <TableCell>{user.keterangan}</TableCell>
                <TableCell align="right">
                  {user.jumlah.toLocaleString("de-DE")}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarBankMasuk({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Bukti
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Bank Masuk
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              COA
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Keterangan
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Jumlah</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarBankMasuk/bankMasuk/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noBukti}
              </TableCell>
              <TableCell>{user.tglBankMasuk}</TableCell>
              <TableCell>{`${user.coa.kodeCOA} - ${user.coa.namaCOA}`}</TableCell>
              <TableCell>{user.keterangan}</TableCell>
              <TableCell align="right">
                {user.jumlah.toLocaleString("de-DE")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableBankMasuk({ id, currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Bukti
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Bank Masuk
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              COA
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Keterangan
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Jumlah</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            let newTglBankMasuk = new Date(user.bankmasuk.tglBankMasuk);
            let tempTglBankMasuk = `${newTglBankMasuk
              .getDate()
              .toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}/${(newTglBankMasuk.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${newTglBankMasuk.getFullYear()}`;
            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(`/daftarBankMasuk/bankMasuk/${id}/${user.id}`);
                }}
              >
                <TableCell component="th" scope="row">
                  {user.bankmasuk.noBukti}
                </TableCell>
                <TableCell>{tempTglBankMasuk}</TableCell>
                <TableCell>{`${user.coa.kodeCOA} - ${user.coa.namaCOA}`}</TableCell>
                <TableCell>{user.keterangan}</TableCell>
                <TableCell align="right">
                  {user.jumlah.toLocaleString("de-DE")}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarBankKeluar({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Bukti
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Bank Keluar
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              COA
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Keterangan
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Jumlah</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarBankKeluar/bankKeluar/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noBukti}
              </TableCell>
              <TableCell>{user.tglBankKeluar}</TableCell>
              <TableCell>{`${user.coa.kodeCOA} - ${user.coa.namaCOA}`}</TableCell>
              <TableCell>{user.keterangan}</TableCell>
              <TableCell align="right">
                {user.jumlah.toLocaleString("de-DE")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableBankKeluar({ id, currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Bukti
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Bank Keluar
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              COA
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Keterangan
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Jumlah</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            let newTglBankKeluar = new Date(user.bankkeluar.tglBankKeluar);
            let tempTglBankKeluar = `${newTglBankKeluar
              .getDate()
              .toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}/${(newTglBankKeluar.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${newTglBankKeluar.getFullYear()}`;
            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(`/daftarBankKeluar/bankKeluar/${id}/${user.id}`);
                }}
              >
                <TableCell component="th" scope="row">
                  {user.bankkeluar.noBukti}
                </TableCell>
                <TableCell>{tempTglBankKeluar}</TableCell>
                <TableCell>{`${user.coa.kodeCOA} - ${user.coa.namaCOA}`}</TableCell>
                <TableCell>{user.keterangan}</TableCell>
                <TableCell align="right">
                  {user.jumlah.toLocaleString("de-DE")}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableNeracaSaldo({
  currentPosts,
  totalDebet,
  totalKredit,
  isCetakExcel,
  tableRef,
}) {
  const classes = useStylesNoColor();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }} ref={tableRef}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama Rekening
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Saldo Awal
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Debet
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kredit
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Saldo Akhir</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user._id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
              }}
            >
              <TableCell component="th" scope="row">
                {user.kodeCOA}
              </TableCell>
              <TableCell>{user.namaCOA}</TableCell>
              <TableCell align="right">
                {isCetakExcel === false
                  ? parseInt(user.saldoAwal).toLocaleString("de-DE")
                  : parseInt(user.saldoAwal)}
              </TableCell>
              <TableCell align="right">
                {isCetakExcel === false
                  ? parseInt(user.debet).toLocaleString("de-DE")
                  : parseInt(user.debet)}
              </TableCell>
              <TableCell align="right">
                {isCetakExcel === false
                  ? parseInt(user.kredit).toLocaleString("de-DE")
                  : parseInt(user.kredit)}
              </TableCell>
              <TableCell align="right">
                {isCetakExcel === false
                  ? parseInt(user.saldoAkhir).toLocaleString("de-DE")
                  : parseInt(user.saldoAkhir)}
              </TableCell>
            </TableRow>
          ))}
          <TableRow
            key={"count"}
            sx={{
              bgcolor: Colors.grey300,
            }}
          >
            <TableCell component="th" scope="row"></TableCell>
            <TableCell></TableCell>
            <TableCell>
              <Typography sx={{ fontWeight: 700 }}>Balance :</Typography>
            </TableCell>
            <TableCell align="right">
              {isCetakExcel === false
                ? parseInt(totalDebet).toLocaleString("de-DE")
                : parseInt(totalDebet)}
            </TableCell>
            <TableCell align="right">
              {isCetakExcel === false
                ? parseInt(totalKredit).toLocaleString("de-DE")
                : parseInt(totalKredit)}
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
          <TableRow
            key={"count"}
            sx={{
              bgcolor: Colors.grey300,
            }}
          >
            <TableCell component="th" scope="row"></TableCell>
            <TableCell></TableCell>
            <TableCell>
              <Typography sx={{ fontWeight: 700 }}>Selisih :</Typography>
            </TableCell>
            {isCetakExcel === false ? (
              <TableCell align="right">
                {totalDebet - totalKredit > 1 || totalDebet - totalKredit < -1
                  ? (totalDebet - totalKredit).toLocaleString("de-DE")
                  : 0}
              </TableCell>
            ) : (
              <TableCell align="right">
                {totalDebet - totalKredit > 1 || totalDebet - totalKredit < -1
                  ? totalDebet - totalKredit
                  : 0}
              </TableCell>
            )}
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarTebus({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Sbg
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pinjaman
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Kasir</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarTebus/tebus/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noSbg}
              </TableCell>
              <TableCell>{user.noAju}</TableCell>
              <TableCell>{user.tanggalAju}</TableCell>
              <TableCell>{user.customer.namaCustomer}</TableCell>
              <TableCell>{user.customer.alamatCustomer}</TableCell>
              <TableCell>{user.coa.kodeCOA}</TableCell>
              <TableCell align="right">
                {(user.pinjamanAju + user.nilaiTopup).toLocaleString("de-DE")}
              </TableCell>
              <TableCell>{user.user.username}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarJurnalUmum({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Bukti
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tanggal
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Debet
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Kredit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
                backgroundColor:
                  user.totalDebet - user.totalKredit !== 0
                    ? "#f79892"
                    : "white",
              }}
              onClick={() => {
                navigate(`/daftarJurnalUmum/jurnalUmum/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noBukti}
              </TableCell>
              <TableCell>{user.tglJurnalUmum}</TableCell>
              <TableCell align="right">
                {user.totalDebet.toLocaleString("de-DE")}
              </TableCell>
              <TableCell align="right">
                {user.totalKredit.toLocaleString("de-DE")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableJurnalUmum({ id, currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Account
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Keterangan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Debet
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kredit
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>OP ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((jurnalUmumChild, index) => {
            return (
              <TableRow
                key={jurnalUmumChild.kodeStok}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                  bgcolor:
                    jurnalUmumChild.transactionId % 2 === 0
                      ? Colors.green100
                      : Colors.yellow100,
                }}
                onClick={() => {
                  navigate(
                    `/daftarJurnalUmum/jurnalUmum/${id}/${jurnalUmumChild.id}`
                  );
                }}
              >
                <TableCell component="th" scope="row">
                  {jurnalUmumChild.coa.kodeCOA}
                </TableCell>
                <TableCell>{jurnalUmumChild.coa.namaCOA}</TableCell>
                <TableCell>{jurnalUmumChild.keterangan}</TableCell>
                <TableCell align="right">
                  {jurnalUmumChild.debet.toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right">
                  {jurnalUmumChild.kredit.toLocaleString("de-DE")}
                </TableCell>
                <TableCell>{jurnalUmumChild.user.username}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarPerpanjangan({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Kwitansi
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Sbg
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Perp.
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Jt. Tempo 1
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Jt. Tempo 2
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarPerpanjangan/perpanjangan/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noKwitansi}
              </TableCell>
              <TableCell>{user.noSbg}</TableCell>
              <TableCell>{user.tglPerpanjangan}</TableCell>
              <TableCell>{user.tglJtTempo1}</TableCell>
              <TableCell>{user.tglJtTempo2}</TableCell>
              <TableCell>{user.customer.namaCustomer}</TableCell>
              <TableCell>{user.coa.kodeCOA}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarCicilan({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Kwitansi
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Sbg
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Cicilan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Cicilan</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarCicilan/cicilan/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noKwitansi}
              </TableCell>
              <TableCell>{user.noSbg}</TableCell>
              <TableCell>{user.tglCicilan}</TableCell>
              <TableCell>{user.customer.namaCustomer}</TableCell>
              <TableCell>{user.coa.kodeCOA}</TableCell>
              <TableCell align="right">
                {user.cicilan.toLocaleString("de-DE")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableJualAgunan({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Jual
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Jual
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Sbg
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pembeli
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Agunan</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/jualAgunan/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noJual}
              </TableCell>
              <TableCell>{user.tglJual}</TableCell>
              <TableCell>{user.noSbg}</TableCell>
              <TableCell>{user.namaPembeli}</TableCell>
              <TableCell>{user.jaminan.ketJam}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableRegisterFidusia({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama/NIK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tpt/Tgl Lahir
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              JK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pkj
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Cr. By
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/registerFidusia/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                <p>{user.customer.namaCustomer}</p>
                <p>{user.customer.nikCustomer}</p>
              </TableCell>
              <TableCell>
                <p>{user.customer.tempatLahirCustomer}</p>
                <p>{formatDate(user.customer.tanggalLahirCustomer)}</p>
              </TableCell>
              <TableCell>
                {user.customer.jenisKelaminCustomer === "LAKI-LAKI" ? "L" : "P"}
              </TableCell>
              <TableCell>{user.customer.alamatCustomer}</TableCell>
              <TableCell>{user.customer.pekerjaanCustomer}</TableCell>
              <TableCell>{user.user ? user.user.username : "-"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableSurveyFidusia({ currentPosts, tipeUser }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama/NIK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tpt/Tgl Lahir
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              JK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pkj
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Cr. By
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            let tempBgcolor = "white";
            if (user.statusSurvey === "ACC") {
              tempBgcolor = Colors.green400;
            } else if (user.statusSurvey === "REJECT") {
              tempBgcolor = Colors.red400;
            } else if (user.statusSurvey === "PENDING") {
              tempBgcolor = Colors.blue100;
            }

            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  bgcolor: tempBgcolor,
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (
                    tipeUser === "SURVEYOR" &&
                    user.statusSurveyManager !== "ACC"
                  ) {
                    navigate(`/surveyFidusia/${user.id}/editLangsung`);
                  } else {
                    navigate(`/surveyFidusia/${user.id}`);
                  }
                }}
              >
                <TableCell component="th" scope="row">
                  <p>{user.registerfidusia.customer.namaCustomer}</p>
                  <p>{user.registerfidusia.customer.nikCustomer}</p>
                </TableCell>
                <TableCell>
                  <p>{user.registerfidusia.customer.tempatLahirCustomer}</p>
                  <p>
                    {formatDate(
                      user.registerfidusia.customer.tanggalLahirCustomer
                    )}
                  </p>
                </TableCell>
                <TableCell>
                  {user.registerfidusia.customer.jenisKelaminCustomer ===
                  "LAKI-LAKI"
                    ? "L"
                    : "P"}
                </TableCell>
                <TableCell>
                  {user.registerfidusia.customer.alamatCustomer}
                </TableCell>
                <TableCell>
                  {user.registerfidusia.customer.pekerjaanCustomer}
                </TableCell>
                <TableCell>{user.user ? user.user.username : "-"}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableSurveyManagerFidusia({ currentPosts, tipeUser }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama/NIK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tpt/Tgl Lahir
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              JK
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pkj
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Cr. By
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            let tempBgcolor = "white";
            if (user.statusSurveyManager === "ACC") {
              tempBgcolor = Colors.green400;
            } else if (user.statusSurveyManager === "REJECT") {
              tempBgcolor = Colors.red400;
            }

            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  bgcolor: tempBgcolor,
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (tipeUser === "SURVEYOR") {
                    navigate(`/surveyManagerFidusia/${user.id}/editLangsung`);
                  } else {
                    navigate(`/surveyManagerFidusia/${user.id}`);
                  }
                }}
              >
                <TableCell component="th" scope="row">
                  <p>{user.registerfidusia.customer.namaCustomer}</p>
                  <p>{user.registerfidusia.customer.nikCustomer}</p>
                </TableCell>
                <TableCell>
                  <p>{user.registerfidusia.customer.tempatLahirCustomer}</p>
                  <p>
                    {formatDate(
                      user.registerfidusia.customer.tanggalLahirCustomer
                    )}
                  </p>
                </TableCell>
                <TableCell>
                  {user.registerfidusia.customer.jenisKelaminCustomer ===
                  "LAKI-LAKI"
                    ? "L"
                    : "P"}
                </TableCell>
                <TableCell>
                  {user.registerfidusia.customer.alamatCustomer}
                </TableCell>
                <TableCell>
                  {user.registerfidusia.customer.pekerjaanCustomer}
                </TableCell>
                <TableCell>{user.user ? user.user.username : "-"}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarPengajuanFidusia({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Perjanjian
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pinjaman
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Kasir</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarPengajuanFidusia/pengajuanFidusia/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noAju}
              </TableCell>
              <TableCell>{user.noPerjanjian}</TableCell>
              <TableCell>{user.tanggalAju}</TableCell>
              <TableCell>{user.customer.namaCustomer}</TableCell>
              <TableCell>{user.customer.alamatCustomer}</TableCell>
              <TableCell align="right">
                {user.pinjamanAju.toLocaleString("de-DE")}
              </TableCell>
              <TableCell>{user.user.username}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarApprovalFidusia({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Perjanjian
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Approval
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pinjaman
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>User Approve</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                bgcolor: user.isReject === true && Colors.red400,
                cursor: "pointer",
              }}
              onClick={() => {
                if (user.isReject === true) {
                  navigate(
                    `/daftarApprovalFidusia/approvalFidusia/reject/${user.id}`
                  );
                } else {
                  navigate(`/daftarApprovalFidusia/approvalFidusia/${user.id}`);
                }
              }}
            >
              <TableCell component="th" scope="row">
                {user.noAju}
              </TableCell>
              <TableCell>{user.noPerjanjian}</TableCell>
              <TableCell>{user.tanggalAju}</TableCell>
              <TableCell>{user.tglApproval}</TableCell>
              <TableCell>{user.customer.namaCustomer}</TableCell>
              <TableCell>{user.coa.kodeCOA}</TableCell>
              <TableCell align="right">
                {user.pinjamanAju.toLocaleString("de-DE")}
              </TableCell>
              <TableCell>{user.user.username}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarPenarikanFidusia({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Perjanjian
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Penarikan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Approval
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pinjaman
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>User Approve</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                if (user.isReject === true) {
                  navigate(
                    `/daftarPenarikanFidusia/penarikanFidusia/reject/${user.id}`
                  );
                } else {
                  navigate(
                    `/daftarPenarikanFidusia/penarikanFidusia/${user.id}`
                  );
                }
              }}
            >
              <TableCell component="th" scope="row">
                {user.noAju}
              </TableCell>
              <TableCell>{user.noPerjanjian}</TableCell>
              <TableCell>{user.tglPenarikan}</TableCell>
              <TableCell>{user.tanggalAju}</TableCell>
              <TableCell>{user.tglApproval}</TableCell>
              <TableCell>{user.customer.namaCustomer}</TableCell>
              <TableCell>{user.coa.kodeCOA}</TableCell>
              <TableCell align="right">
                {user.pinjamanAju.toLocaleString("de-DE")}
              </TableCell>
              <TableCell>{user.user.username}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarBuktiPencairanFidusia({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Perjanjian
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Approval
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Pinjaman
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>User Approve</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(
                  `/daftarBuktiPencairanFidusia/buktiPencairanFidusia/${user.id}`
                );
              }}
            >
              <TableCell component="th" scope="row">
                {user.noAju}
              </TableCell>
              <TableCell>{user.noPerjanjian}</TableCell>
              <TableCell>{user.tanggalAju}</TableCell>
              <TableCell>{user.tglApproval}</TableCell>
              <TableCell>{user.customer.namaCustomer}</TableCell>
              <TableCell>{user.coa.kodeCOA}</TableCell>
              <TableCell align="right">
                {user.pinjamanAju.toLocaleString("de-DE")}
              </TableCell>
              <TableCell>{user.user.username}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarAngsuranFidusia({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Perjanjian
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Approval
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Pinjaman</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                bgcolor: user.sisaBulan === 0 && Colors.red400,
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarAngsuranFidusia/angsuranFidusia/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noAju}
              </TableCell>
              <TableCell>{user.noPerjanjian}</TableCell>
              <TableCell>{user.tanggalAju}</TableCell>
              <TableCell>{user.tglApproval}</TableCell>
              <TableCell>{user.customer.namaCustomer}</TableCell>
              <TableCell>{user.coa.kodeCOA}</TableCell>
              <TableCell align="right">
                {user.pinjamanAju.toLocaleString("de-DE")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarHutangDendaFidusia({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Perjanjian
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Bayar
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Hutang Denda
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Bayar
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Hutang Denda Baru</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                bgcolor: user.isBayarTerakhir === true && Colors.red400,
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarHutangDendaFidusia/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noAju}
              </TableCell>
              <TableCell>{user.noPerjanjian}</TableCell>
              <TableCell>{user.tglBayar}</TableCell>
              <TableCell>
                {user.pengajuanfidusia.customer.namaCustomer}
              </TableCell>
              <TableCell>{user.coa.kodeCOA}</TableCell>
              <TableCell align="right">
                {user.hutangDendaBefore.toLocaleString("de-DE")}
              </TableCell>
              <TableCell align="right">
                {user.bayar.toLocaleString("de-DE")}
              </TableCell>
              <TableCell align="right">
                {user.hutangDenda.toLocaleString("de-DE")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarUbahHutangDendaFidusia({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Perjanjian
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Ubah
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Hutang Denda
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Hutang Denda Baru</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                bgcolor: user.isBayarTerakhir === true && Colors.red400,
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarUbahHutangDendaFidusia/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noAju}
              </TableCell>
              <TableCell>{user.noPerjanjian}</TableCell>
              <TableCell>{user.tglUbah}</TableCell>
              <TableCell>
                {user.pengajuanfidusia.customer.namaCustomer}
              </TableCell>
              <TableCell align="right">
                {user.hutangDendaBefore.toLocaleString("de-DE")}
              </TableCell>
              <TableCell align="right">
                {user.hutangDenda.toLocaleString("de-DE")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarInfoNasabahFidusia({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Perjanjian
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Aju
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Approval
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Atas Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Kas
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Pinjaman</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(
                  `/daftarInfoNasabahFidusia/infoNasabahFidusia/${user.id}`
                );
              }}
            >
              <TableCell component="th" scope="row">
                {user.noAju}
              </TableCell>
              <TableCell>{user.noPerjanjian}</TableCell>
              <TableCell>{user.tanggalAju}</TableCell>
              <TableCell>{user.tglApproval}</TableCell>
              <TableCell>{user.customer.namaCustomer}</TableCell>
              <TableCell>{user.coa.kodeCOA}</TableCell>
              <TableCell align="right">
                {user.pinjamanAju.toLocaleString("de-DE")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableAngsuran({ id, currentPosts, totalSaldo, dataStart }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Bayar
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Jt
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Keterlambatan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Kwitansi
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              A. Modal
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              A. Bunga
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              A/bulan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Hutang Denda
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Denda
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Potongan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Saldo
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              SP1
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              SP2
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              SP3
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              S. Panggilan
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((angsuran, index) => {
            if (dataStart > 0 && index === 0) {
              let tempTotalAngPerBulan = angsuran.angPerBulan * dataStart;
              totalSaldo -= tempTotalAngPerBulan;
            }

            totalSaldo -= angsuran.angPerBulan;
            return (
              <TableRow
                key={angsuran.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  bgcolor: angsuran.isPercepatan && Colors.blue50,
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(
                    `/daftarAngsuranFidusia/angsuranFidusia/${id}/${angsuran.no}`
                  );
                }}
              >
                <TableCell component="th" scope="row">
                  {angsuran.tglBayar}
                </TableCell>
                <TableCell>{angsuran.tglJatuhTempo}</TableCell>
                <TableCell>{angsuran.keterlambatan} hari</TableCell>
                <TableCell>{angsuran.noKwitansi}</TableCell>
                <TableCell>{angsuran.no}</TableCell>
                <TableCell align="right">
                  {parseInt(angsuran.angModal).toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right">
                  {parseInt(angsuran.angBunga).toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right">
                  {angsuran.angPerBulan.toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right">
                  {angsuran.hutangDenda.toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right">
                  {angsuran.denda.toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right">
                  {angsuran.potongan.toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right">
                  {totalSaldo.toLocaleString("de-DE")}
                </TableCell>
                <TableCell>
                  {angsuran.sp1 && formatDate(angsuran.sp1)}
                </TableCell>
                <TableCell>
                  {angsuran.sp2 && formatDate(angsuran.sp2)}
                </TableCell>
                <TableCell>
                  {angsuran.sp3 && formatDate(angsuran.sp3)}
                </TableCell>
                <TableCell>
                  {angsuran.sPanggilan && formatDate(angsuran.sPanggilan)}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableAngsuranInfoNasabah({
  id,
  currentPosts,
  totalSaldo,
  dataStart,
}) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Bayar
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Jt
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Keterlambatan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Kwitansi
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              A. Modal
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              A. Bunga
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              A/bulan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Hutang Denda
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Denda
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Potongan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Saldo
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              SP1
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              SP2
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              SP3
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              S. Panggilan
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((angsuran, index) => {
            if (dataStart > 0 && index === 0) {
              let tempTotalAngPerBulan = angsuran.angPerBulan * dataStart;
              totalSaldo -= tempTotalAngPerBulan;
            }

            totalSaldo -= angsuran.angPerBulan;
            return (
              <TableRow
                key={angsuran.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  bgcolor: angsuran.isPercepatan && Colors.blue50,
                }}
              >
                <TableCell component="th" scope="row">
                  {angsuran.tglBayar}
                </TableCell>
                <TableCell>{angsuran.tglJatuhTempo}</TableCell>
                <TableCell>{angsuran.keterlambatan} hari</TableCell>
                <TableCell>{angsuran.noKwitansi}</TableCell>
                <TableCell>{angsuran.no}</TableCell>
                <TableCell align="right">
                  {parseInt(angsuran.angModal).toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right">
                  {parseInt(angsuran.angBunga).toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right">
                  {angsuran.angPerBulan.toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right">
                  {angsuran.hutangDenda.toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right">
                  {angsuran.denda.toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right">
                  {angsuran.potongan.toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right">
                  {totalSaldo.toLocaleString("de-DE")}
                </TableCell>
                <TableCell>
                  {angsuran.sp1 && formatDate(angsuran.sp1)}
                </TableCell>
                <TableCell>
                  {angsuran.sp2 && formatDate(angsuran.sp2)}
                </TableCell>
                <TableCell>
                  {angsuran.sp3 && formatDate(angsuran.sp3)}
                </TableCell>
                <TableCell>
                  {angsuran.sPanggilan && formatDate(angsuran.sPanggilan)}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableAngsuranSP({ id, currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No.
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              SP1
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              SP2
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              SP3
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>S. Panggilan</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((angsuran, index) => (
            <TableRow
              key={angsuran.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
              }}
            >
              <TableCell component="th" scope="row">
                {angsuran.no}
              </TableCell>
              <TableCell>{angsuran.sp1}</TableCell>
              <TableCell>{angsuran.sp2}</TableCell>
              <TableCell>{angsuran.sp3}</TableCell>
              <TableCell>{angsuran.sPanggilan}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableAngsuranSPInfoNasabah({ id, currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No.
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              SP1
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              SP2
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              SP3
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>S. Panggilan</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((angsuran, index) => (
            <TableRow
              key={angsuran.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
              }}
            >
              <TableCell component="th" scope="row">
                {angsuran.no}
              </TableCell>
              <TableCell>{angsuran.sp1}</TableCell>
              <TableCell>{angsuran.sp2}</TableCell>
              <TableCell>{angsuran.sp3}</TableCell>
              <TableCell>{angsuran.sPanggilan}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarSp1Fidusia({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Surat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Surat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Perjanjian
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Ang. Ke-
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Approval
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Atas Nama</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarSp1Fidusia/sp1Fidusia/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noSurat}
              </TableCell>
              <TableCell>{user.tglSurat}</TableCell>
              <TableCell>{user.noPerjanjian}</TableCell>
              <TableCell>{user.no}</TableCell>
              <TableCell>{user.tglApproval}</TableCell>
              <TableCell>
                {user.angsuranfidusia.pengajuanfidusia.customer.namaCustomer}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarSp2Fidusia({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Surat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Surat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Perjanjian
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Ang. Ke-
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Approval
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Atas Nama</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarSp2Fidusia/sp2Fidusia/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noSurat}
              </TableCell>
              <TableCell>{user.tglSurat}</TableCell>
              <TableCell>{user.noPerjanjian}</TableCell>
              <TableCell>{user.no}</TableCell>
              <TableCell>{user.tglApproval}</TableCell>
              <TableCell>
                {user.angsuranfidusia.pengajuanfidusia.customer.namaCustomer}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarSp3Fidusia({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Surat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Surat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Perjanjian
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Ang. Ke-
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Approval
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Atas Nama</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarSp3Fidusia/sp3Fidusia/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.noSurat}
              </TableCell>
              <TableCell>{user.tglSurat}</TableCell>
              <TableCell>{user.noPerjanjian}</TableCell>
              <TableCell>{user.no}</TableCell>
              <TableCell>{user.tglApproval}</TableCell>
              <TableCell>
                {user.angsuranfidusia.pengajuanfidusia.customer.namaCustomer}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarSuratPanggilanFidusia({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Surat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Surat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Perjanjian
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Ang. Ke-
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Approval
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Atas Nama</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(
                  `/daftarSuratPanggilanFidusia/suratPanggilanFidusia/${user.id}`
                );
              }}
            >
              <TableCell component="th" scope="row">
                {user.noSurat}
              </TableCell>
              <TableCell>{user.tglSurat}</TableCell>
              <TableCell>{user.noPerjanjian}</TableCell>
              <TableCell>{user.no}</TableCell>
              <TableCell>{user.tglApproval}</TableCell>
              <TableCell>
                {user.angsuranfidusia.pengajuanfidusia.customer.namaCustomer}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDaftarSuratPenarikanFidusia({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Surat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Surat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Perjanjian
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Ang. Ke-
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Approval
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Atas Nama</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(
                  `/daftarSuratPenarikanFidusia/suratPenarikanFidusia/${user.id}`
                );
              }}
            >
              <TableCell component="th" scope="row">
                {user.noSurat}
              </TableCell>
              <TableCell>{user.tglSurat}</TableCell>
              <TableCell>{user.noPerjanjian}</TableCell>
              <TableCell>{user.no}</TableCell>
              <TableCell>{user.tglApproval}</TableCell>
              <TableCell>
                {user.angsuranfidusia.pengajuanfidusia.customer.namaCustomer}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDashboardCabangNplDetailGadai({ juals }) {
  const classes = useStyles();

  let finalTotalJuals = 0;
  let finalKuantitasJuals = 0;
  let finalTotalTunggakkan = 0;
  let finalKuantitasTunggakkan = 0;
  let finalTotalTitip = 0;
  let finalKuantitasTitip = 0;
  let finalNpl = 0;
  let finalKuantitasNpl = 0;

  {
    juals.map((user, index) => {
      finalTotalJuals += user.totalJuals;
      finalKuantitasJuals += user.kuantitasJuals;
      finalTotalTunggakkan += user.totalTunggakkan;
      finalKuantitasTunggakkan += user.kuantitasTunggakkan;
      finalTotalTitip += user.totalTitip;
      finalKuantitasTitip += user.kuantitasTitip;
    });
  }

  finalNpl = ((finalTotalTunggakkan - finalTotalTitip) / finalTotalJuals) * 100;
  finalKuantitasNpl =
    ((finalKuantitasTunggakkan - finalKuantitasTitip) / finalKuantitasJuals) *
    100;

  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              align="center"
              rowSpan={2}
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Cabang
            </TableCell>
            <TableCell
              align="center"
              colSpan={2}
              sx={{ fontWeight: "bold" }}
              className={classes.tableBottomRightBorder}
            >
              Total Piutang
            </TableCell>
            <TableCell
              align="center"
              colSpan={2}
              sx={{ fontWeight: "bold" }}
              className={classes.tableBottomRightBorder}
            >
              J. Tempo
            </TableCell>
            <TableCell
              align="center"
              colSpan={2}
              sx={{ fontWeight: "bold" }}
              className={classes.tableBottomRightBorder}
            >
              Titip
            </TableCell>
            <TableCell
              align="center"
              colSpan={2}
              sx={{ fontWeight: "bold" }}
              className={classes.tableBottomRightBorder}
            >
              NPL
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Rupiah
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Qty
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Rupiah
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Qty
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Rupiah
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Qty
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Rupiah
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Qty
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {juals.map((user, index) => (
            <TableRow>
              <TableCell component="th" scope="row">
                {user.namaCabang}
              </TableCell>
              <TableCell align="right">
                {user.totalJuals.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.kuantitasJuals.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.totalTunggakkan.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.kuantitasTunggakkan.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.totalTitip.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.kuantitasTitip.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.npl && user.npl.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.kuantitasNpl && user.kuantitasNpl.toLocaleString("en-US")}
              </TableCell>
            </TableRow>
          ))}

          <TableRow>
            <TableCell component="th" scope="row">
              Total
            </TableCell>
            <TableCell align="right">
              {finalTotalJuals.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalKuantitasJuals.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalTotalTunggakkan.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalKuantitasTunggakkan.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalTotalTitip.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalKuantitasTitip.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalNpl.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalKuantitasNpl.toLocaleString("en-US")}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableDashboardCabangNplDetailFidusia({ juals }) {
  const classes = useStyles();

  let finalTotalJuals = 0;
  let finalKuantitasJuals = 0;
  let finalTotalTunggakkan = 0;
  let finalKuantitasTunggakkan = 0;
  let finalNplSemua = 0;
  let finalKuantitasNplSemua = 0;
  let finalTotalTitip = 0;
  let finalKuantitasTitip = 0;
  let finalNpl = 0;
  let finalKuantitasNpl = 0;

  {
    juals.map((user, index) => {
      finalTotalJuals += user.totalJuals;
      finalKuantitasJuals += user.kuantitasJuals;
      finalTotalTunggakkan += user.totalTunggakkan;
      finalKuantitasTunggakkan += user.kuantitasTunggakkan;
      finalTotalTitip += user.totalTitip;
      finalKuantitasTitip += user.kuantitasTitip;
    });
  }

  finalNplSemua = (finalTotalTunggakkan / finalTotalJuals) * 100;
  finalKuantitasNplSemua =
    (finalKuantitasTunggakkan / finalKuantitasJuals) * 100;

  finalNpl = ((finalTotalTunggakkan - finalTotalTitip) / finalTotalJuals) * 100;
  finalKuantitasNpl =
    ((finalKuantitasTunggakkan - finalKuantitasTitip) / finalKuantitasJuals) *
    100;

  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              align="center"
              rowSpan={2}
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Cabang
            </TableCell>
            <TableCell
              align="center"
              colSpan={2}
              sx={{ fontWeight: "bold" }}
              className={classes.tableBottomRightBorder}
            >
              Total Piutang
            </TableCell>
            <TableCell
              align="center"
              colSpan={2}
              sx={{ fontWeight: "bold" }}
              className={classes.tableBottomRightBorder}
            >
              J. Tempo
            </TableCell>
            <TableCell
              align="center"
              colSpan={2}
              sx={{ fontWeight: "bold" }}
              className={classes.tableBottomRightBorder}
            >
              NPL Semua
            </TableCell>
            <TableCell
              align="center"
              colSpan={2}
              sx={{ fontWeight: "bold" }}
              className={classes.tableBottomRightBorder}
            >
              Tarik
            </TableCell>
            <TableCell
              align="center"
              colSpan={2}
              sx={{ fontWeight: "bold" }}
              className={classes.tableBottomRightBorder}
            >
              NPL Di Luar Tarikan
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Rupiah
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Qty
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Rupiah
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Qty
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Rupiah
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Qty
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Rupiah
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Qty
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Rupiah
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
              align="right"
            >
              Qty
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {juals.map((user, index) => (
            <TableRow>
              <TableCell component="th" scope="row">
                {user.namaCabang}
              </TableCell>
              <TableCell align="right">
                {user.totalJuals.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.kuantitasJuals.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.totalTunggakkan.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.kuantitasTunggakkan.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.nplSemua && user.nplSemua.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.kuantitasNplSemua &&
                  user.kuantitasNplSemua.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.totalTitip.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.kuantitasTitip.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.npl && user.npl.toLocaleString("en-US")}
              </TableCell>
              <TableCell align="right">
                {user.kuantitasNpl && user.kuantitasNpl.toLocaleString("en-US")}
              </TableCell>
            </TableRow>
          ))}

          <TableRow>
            <TableCell component="th" scope="row">
              Total
            </TableCell>
            <TableCell align="right">
              {finalTotalJuals.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalKuantitasJuals.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalTotalTunggakkan.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalKuantitasTunggakkan.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalNplSemua.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalKuantitasNplSemua.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalTotalTitip.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalKuantitasTitip.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalNpl.toLocaleString("en-US")}
            </TableCell>
            <TableCell align="right">
              {finalKuantitasNpl.toLocaleString("en-US")}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
